// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3TA4F","inputDescription":"styles_inputDescription__aj-La"};